import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PlanScreen } from '../features/plan/PlanScreen.tsx';

export const Route = createFileRoute('/plan')({
  validateSearch: z.object({
    view: z.enum(['today', 'history']).optional().catch(undefined),
    week: z.iso.date().optional().catch(undefined),
  }),
  component: PlanRoute,
});

/**
 * Opens on the week (`?week=<a day>` for another one); `?view=today` shows Today,
 * `?view=history` what was cooked.
 */
function PlanRoute() {
  const { view, week } = Route.useSearch();
  return <PlanScreen view={view ?? 'week'} week={week} />;
}
